import { IManifest } from 'm3u8-parser';

import { PlaylistPostParseValidatorStage } from '@streamLoader/PlaylistDecrypt/PlaylistValidators/PlaylistPostParserValidatorStage/PlaylistPostParseValidatorStage';

export class V1PostParseValidator extends PlaylistPostParseValidatorStage {
  constructor() {
    super();
  }

  public validateScheme(data: IManifest, activeScheme: string, activeKey: string): boolean {
    const mouflonSchemeAndKeyArray: string[] | unknown = data?.custom?.mmpCorruptionScheme;

    return (
      Array.isArray(mouflonSchemeAndKeyArray) &&
      mouflonSchemeAndKeyArray.includes(activeScheme) &&
      mouflonSchemeAndKeyArray.includes(activeKey)
    );
  }
}
